import CryptoJS from "crypto-js";

const secretKey = "@kozyclan@1234";

export const storeUserData = (user:any) => {
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(user),
    secretKey
  ).toString();
  localStorage.setItem("userData", encryptedData);
};

export const getUserData = () => {
  const encryptedData = localStorage.getItem("userData");
  if (!encryptedData) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption error", error);
    return null;
  }
};

export const clearUserData = () => {
  localStorage.clear();
};
